import { Fragment, useContext, useEffect, useState } from 'react';
import { Col, Card, CardHeader, Table, Form, FormGroup, Label, Input, ModalFooter, Row } from 'reactstrap';
import { Btn } from '../../AbstractElements';
import { useDispatch, useSelector } from 'react-redux';
import CommonModal from '../../Components/Modals/modal';
import Pagination from '../../Components/Pagination/Pagination';
import Empty from '../../Components/Empty/Index';
import SweetAlert from 'sweetalert2';
import { useNavigate } from 'react-router';
import CustomizerContext from '../../_helper/Customizer';
import { addenotesSubject, getenotesSubject, isOpenModal, ModalToggle, statusDeleteenotesSubject, updateenotesSubject, } from '../../store/enotesSubjectSlice';


const EnotesSubjectTable = () => {
  const storeVar = useSelector(state => state.enoteSubject)
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { layoutURL } = useContext(CustomizerContext);
  const toggle = () => dispatch(ModalToggle());
  const [submit, setSubmit] = useState(false);
  const [formVar, setFormVar] = useState({
    keyword: '',
    limit: 30,
    offset: 0,
    currentPage: 1,
    modalTitle: null,
    editState: false,
    title: '',
    subjectId: '',
  });

  useEffect(() => {
    dispatch(getenotesSubject(formVar.limit, formVar.offset, ))
  }, []);

  const pageChange = (page) => {
    const offset = formVar.limit * (page - 1)
    setFormVar((prevFormVar) => ({
      ...prevFormVar,
      currentPage: page,
      offset: offset
    }))
    dispatch(getenotesSubject(formVar.limit, offset,))
  };

  const EditToggleModal = (data) => {
    dispatch(isOpenModal(true))
    setFormVar((prevFormVar) => ({
      ...prevFormVar,
      editState: true,
      subjectId: data._id,
      modalTitle: 'Edit Subject',
      title: data.title,
    }))
  }
  const AddToggleModal = () => {
    dispatch(isOpenModal(true))
    setSubmit(false)
    setFormVar((prevFormVar) => ({
      ...prevFormVar,
      editState: false,
      modalTitle: 'Add Subject',
      title: '',
    }))
  }


  const submitMenu = () => {
    if (titleValid()) {
      setSubmit(true)
      return null
    }
    setSubmit(false)
    if (formVar.editState) {
      dispatch(updateenotesSubject(formVar.subjectId, { title: formVar.title }))
    } else {
      dispatch(addenotesSubject({ title: formVar.title }))
    }
  }


  const titleValid = () => {
    if (!formVar.title) {
      return "Title is required";
    }
  }

  const DeleteModel = (data) => {
    SweetAlert.fire({
      title: 'Are you sure?',
      text: 'Once deleted, you will not be able to recover this imaginary file!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Ok',
      cancelButtonText: 'Cancel',
      reverseButtons: true
    })
      .then((result) => {
        if (result.value) {
          dispatch(statusDeleteenotesSubject(data._id))
        }
      });
  }

  const onNavigate = (data) => {
    navigate('/enotes-chapter/' + layoutURL + '?id=' + data._id)
  }







  return (
    <Fragment>
      <Col sm='12'>
        <Card>
          <CardHeader>
            <Row>
              <Col md="6">
              </Col>
              <Col md="4">
              </Col>
              <Col md="2" className='d-flex justify-content-end align-items-center'>
                <div className="text-end border-2 w-100">
                  <Btn attrBtn={{ color: 'info-gradien', className: 'w-100', size: 'sm', onClick: AddToggleModal }}>
                    Add Subject
                  </Btn>
                </div>
              </Col>
            </Row>

          </CardHeader>
          <div className='table-responsive'>
            <Table hover={true} className='table-border-horizontal table-light'>
              <thead>
                <tr>
                  <th scope='col'>Sl.No</th>
                  <th scope='col'>Name</th>
                  <th scope='col'>Chapters</th>
                  <th scope='col'>Action</th>
                </tr>
              </thead>
              <tbody>
                {storeVar.enotesSubjectData?.map((item, index) => (
                  <tr key={index}>
                    <th scope='row'>{index + 1}</th>
                    <td >{item.title}</td>
                    <td >{item.enoteChapters.length}</td>


                    <td>
                      <div className='d-flex gap-2 align-items-center'>
                        <div className='cursor-pointer bg-light-primary font-primary action-icon'>
                          <i className="fa fa-edit fa-lg" onClick={(e) => EditToggleModal(item)}></i>
                          <div className="tooltipCustom">Edit</div>
                        </div>
                        <div className='cursor-pointer bg-light-primary font-success action-icon'>
                          <i className="fa fa-book fa-lg" onClick={() => onNavigate(item)}></i>
                          <div className="tooltipCustom">Chapters</div>
                        </div>
                        <div className='cursor-pointer bg-light-info font-danger action-icon'>
                          <i className="fa fa-trash fa-lg" onClick={(e) => DeleteModel(item)}></i>
                          <div className="tooltipCustom">Delete</div>
                        </div>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
          {
            storeVar.totalenotesSubject <= 0 && (
              <Empty />
            )
          }
        </Card>
        {
          storeVar.totalenotesSubject > 0 &&
          <Pagination currentPage={formVar.currentPage} totalItem={storeVar.totalenotesSubject}
            itemsPerPage={formVar.limit} showEllipsisAfter={true} visiblePageCount={3} onPageChange={pageChange} />
        }
      </Col>
      <CommonModal isOpen={storeVar.isOpenModal} title={formVar.modalTitle} toggler={toggle} >
        <Form>
          <FormGroup>
            <Label className="col-form-label" for="recipient-name">Title</Label>
            <Input className="form-control" type="text" placeholder='Enter Title' onChange={(e) => setFormVar((prevFormVar) => ({ ...prevFormVar, title: e.target.value }))} value={formVar.title} />
            {submit && titleValid() ? <span className='d-block font-danger'>{titleValid()}</span> : ""}
          </FormGroup>
        </Form>
        <ModalFooter>
          <Btn attrBtn={{ color: 'secondary', onClick: toggle }} >Close</Btn>
          <Btn attrBtn={{ color: 'primary', onClick: submitMenu }}>Save Changes</Btn>
        </ModalFooter>
      </CommonModal>
    </Fragment>
  );
};

export default EnotesSubjectTable;
